<!-- routify:options param-is-page=true -->
<script lang="ts">
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params, redirect } from "@roxi/routify";
  import * as _ from "lodash";
  import * as Sentry from "@sentry/browser";

  const storefrontRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: `/api/retailer/storefronts/${$params.distributor_id}/find_storefront`,
        data: $params,
      });
      return res;
    } catch (e) {
      return { data: null, error: true };
    }
  };

  const load = async () => {
    let res = await storefrontRes();
    if (res.storefront_exists) {
      $redirect(`/storefront/${$params.distributor_id}`);
    } else if (!$params.distributor_id || $params.distributor_id === ":distributor_id") {
      const consoleError = "No distributor id provided for storefronts/find_storefront";
      console.error(consoleError, $params);
      const errorDetails = {
        message: consoleError,
        params: $params,
      };

      Sentry.withScope(scope => {
        scope.setExtras(errorDetails);
        Sentry.captureMessage(consoleError);
      });
      $redirect("/");
    } else {
      $redirect(`/product_listing?distributors=${$params.distributor_id}`);
    }
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <div />
{/await}
